import React from "react";
import './Landing.css';
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Landing = () => {

    const navigate = useNavigate();

    // Function to handle navigation
    const handleRedirect = () => {
     navigate("/contact-us");
   };

  return (
    <div className="phishing-landing-container">
      <div className="phishing-landing-content">
        <div className="phishing-landing-heading">Cyber Security Awareness
        </div>
        <p className="phishing-landing-description">Equip your team to recognize and neutralize phishing threats. 
        </p>
        <Button variant="contained" className="ctaBtn" onClick={handleRedirect}>Connect With Us Today</Button>
      </div>
    </div>
  )
}

export default Landing;